// import React, { useEffect, useState, useCallback } from "react";
// import axiosApi from "../server/service";
// import PieceWorkEmployeeDetail from "../component/PieceWorkEmployeeDetail";
// import {
//   CalendarDaysIcon,
//   FunnelIcon,
//   BriefcaseIcon,
// } from "@heroicons/react/24/outline";



// // ==========================================
// // Types & Interfaces
// // ==========================================

// export type EmployeeType = "Master" | "Karigar" | "job-work" | "Group Work";

// export interface Employee {
//   _id: string;
//   fullName: string;
//   username: string;
//   employeeType?: EmployeeType | null;
//   availabilityStatus: "Available" | "Busy";
//   location: "Mumbai" | "Surat";
//   groupMembers?: { _id?: string; name: string }[];
// }

// export interface PieceWorkTask {
//   lotNumber: string;
//   segmentName: string;
//   pieces: number;
//   assignedAt: string | null;
//   completedAt: string | null;
//   memberName?: string;
//   memberId?: string;
// }

// export interface PieceWorkReportData {
//   employeeId: string;
//   employeeName: string;
//   employeeType: EmployeeType;
//   // Summary object is required now
//   summary: {
//     completed: number;
//     incomplete: number;
//     inProgress: number;
//     total: number;
//   };
//   totalPiecesCompleted: number; // Keep for backward compatibility if needed
//   tasks: PieceWorkTask[];
// }

// interface PieceWorkReportResponse {
//   success: boolean;
//   data?: PieceWorkReportData;
//   message?: string;
// }

// interface UsersApiResponse {
//   success: boolean;
//   data: Employee[];
//   pagination: {
//     total: number;
//     page: number;
//     limit: number;
//     totalPages: number;
//   };
// }

// // -- Stats Types --
// interface OrdersStats {
//   total: number;
//   completed: number;
//   wip: number;
//   notStarted: number;
// }

// interface EmployeesStats {
//   total: number;
//   masters: number;
//   karigars: number;
//   jobwork: number;
//   groupwork: number;
// }

// interface DashboardStats {
//   orders: OrdersStats;
//   employees: EmployeesStats;
//   designTemplates: number;
// }

// interface DashboardStatsResponse {
//   success: boolean;
//   data?: DashboardStats;
//   message?: string;
// }

// // ==========================================
// // Constants
// // ==========================================

// const EMPLOYEE_TYPE_OPTIONS: { label: string; value: "" | EmployeeType }[] = [
//   { label: "All Roles", value: "" },
//   { label: "Master", value: "Master" },
//   { label: "Karigar", value: "Karigar" },
//   { label: "Job Work", value: "job-work" },
//   { label: "Group Work", value: "Group Work" },
// ];

// // ==========================================
// // Main Component
// // ==========================================

// const PieceWorkDashboardAdmin: React.FC = () => {
//   // -----------------------------
//   // 1. State Management
//   // -----------------------------

//   // View State
//   const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(
//     null
//   );

//   // Filters State
//   const [startDate, setStartDate] = useState<string>(() => {
//     const d = new Date();
//     d.setDate(d.getDate() - 7);
//     return d.toISOString().slice(0, 10);
//   });
//   const [endDate, setEndDate] = useState<string>(() =>
//     new Date().toISOString().slice(0, 10)
//   );
  
//   // Search & Filter (Now Backend Driven)
//   const [searchName, setSearchName] = useState<string>("");
//   const [roleFilter, setRoleFilter] = useState<"" | EmployeeType>("");

//   // Pagination State
//   const [page, setPage] = useState<number>(1);
//   const [limit, setLimit] = useState<number>(12); // Default Desktop
//   const [totalPages, setTotalPages] = useState<number>(1);
//   const [totalRecords, setTotalRecords] = useState<number>(0);

//   // Data State: Employees
//   const [employees, setEmployees] = useState<Employee[]>([]);
//   const [employeesLoading, setEmployeesLoading] = useState<boolean>(false);
//   const [employeesError, setEmployeesError] = useState<string | null>(null);

//   // Data State: Stats
//   const [stats, setStats] = useState<DashboardStats | null>(null);
//   const [statsLoading, setStatsLoading] = useState<boolean>(false);
//   const [statsError, setStatsError] = useState<string | null>(null);

//   // Data State: Report
//   const [report, setReport] = useState<PieceWorkReportData | null>(null);
//   const [reportLoading, setReportLoading] = useState<boolean>(false);
//   const [reportError, setReportError] = useState<string | null>(null);

//   // -----------------------------
//   // 2. Responsive Limit Logic
//   // -----------------------------
//   useEffect(() => {
//     const handleResize = () => {
//       const width = window.innerWidth;
//       if (width < 640) {
//         setLimit(8); // Mobile
//       } else if (width < 1024) {
//         setLimit(10); // Tablet (Table ke liye 10 requested)
//       } else {
//         setLimit(12); // Desktop (3x4)
//       }
//     };

//     // Set initial
//     handleResize();

//     // Listen
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // -----------------------------
//   // 3. Data Fetching
//   // -----------------------------

//   // Reset page to 1 when filters change
//   useEffect(() => {
//     setPage(1);
//   }, [searchName, roleFilter]);

//   // Fetch Employees (Backend Pagination & Filtering)
//   useEffect(() => {
//     const fetchEmployees = async () => {
//       try {
//         setEmployeesLoading(true);
//         setEmployeesError(null);

//         // API Call with Filters & Pagination
//         const response = await axiosApi.get<UsersApiResponse>("/api/users/by-type-dashboard", {
//           params: {
//             page,
//             limit,
//             search: searchName,
//             employeeType: roleFilter,
//             includeAll: "true", // Backend will include busy users
//           },
//         });

//         if (response.data.success) {
//           setEmployees(response.data.data);
//           setTotalPages(response.data.pagination.totalPages);
//           setTotalRecords(response.data.pagination.total);
//         } else {
//           setEmployees([]);
//         }
//       } catch (err: any) {
//         console.error("fetchEmployees error:", err);
//         setEmployeesError("Error fetching employees");
//       } finally {
//         setEmployeesLoading(false);
//       }
//     };

//     // Debounce slightly to prevent API spam on typing
//     const timeoutId = setTimeout(() => {
//       fetchEmployees();
//     }, 400);

//     return () => clearTimeout(timeoutId);
//   }, [page, limit, searchName, roleFilter]);

//   // Fetch Stats (Once)
//   useEffect(() => {
//     const fetchStats = async () => {
//       try {
//         setStatsLoading(true);
//         const response = await axiosApi.get<DashboardStatsResponse>(
//           "/api/dashboard/stats"
//         );
//         if (response.data.success) {
//           setStats(response.data.data || null);
//         }
//       } catch (err) {
//         console.error("fetchStats error:", err);
//         setStatsError("Error fetching stats");
//       } finally {
//         setStatsLoading(false);
//       }
//     };
//     fetchStats();
//   }, []);

//   // Fetch Detailed Report
//   const fetchReport = useCallback(
//     async (employee: Employee) => {
//       if (!startDate || !endDate) {
//         setReportError("Please select both Start Date and End Date.");
//         return;
//       }
//       try {
//         setReportLoading(true);
//         setReportError(null);
//         setReport(null);

//         const response = await axiosApi.get<PieceWorkReportResponse>(
//           "api/dashboard/piece-work-report",
//           {
//             params: { startDate, endDate, employeeId: employee._id },
//           }
//         );

//         if (response.data.success) {
//           setReport(response.data.data || null);
//         }
//       } catch (err: any) {
//         setReportError("Error fetching report details");
//       } finally {
//         setReportLoading(false);
//       }
//     },
//     [startDate, endDate]
//   );

//   useEffect(() => {
//     if (selectedEmployee) {
//       fetchReport(selectedEmployee);
//     }
//   }, [selectedEmployee, startDate, endDate, fetchReport]);

//   // -----------------------------
//   // 4. Handlers
//   // -----------------------------

//   const handleEmployeeClick = (employee: Employee) =>
//     setSelectedEmployee(employee);

//   const handleBack = () => {
//     setSelectedEmployee(null);
//     setReport(null);
//     setReportError(null);

//     const end = new Date();
//     const start = new Date();
//     start.setDate(start.getDate() - 7);
    
//     setStartDate(start.toISOString().slice(0, 10));
//     setEndDate(end.toISOString().slice(0, 10));

//   };

//   const handlePrevPage = () => {
//     if (page > 1) setPage((prev) => prev - 1);
//   };

//   const handleNextPage = () => {
//     if (page < totalPages) setPage((prev) => prev + 1);
//   };

//   // -----------------------------
//   // 5. Render Blocks
//   // -----------------------------

//   const renderStatsSection = () => {
//     if (selectedEmployee) return null;

//     return (
//       <div className="mb-6 space-y-3 animate-fade-in">
//         {statsError && (
//           <div className="rounded-xl border border-red-200 bg-red-50 p-3 text-xs text-red-700">
//             {statsError}
//           </div>
//         )}

//         <div className="grid w-full gap-4 md:grid-cols-[2fr,2fr,1.2fr]">
//           {/* Orders Card */}
//           <div className="rounded-2xl border border-gray-100 bg-white p-4 sm:p-5 shadow-md">
//             {statsLoading && !stats ? (
//               <div className="h-28 w-full animate-pulse rounded-xl bg-gray-100" />
//             ) : (
//               <>
//                 <p className="text-[11px] sm:text-xs font-semibold uppercase tracking-wide text-gray-500">
//                   Orders
//                 </p>
//                 <div className="mt-2 flex flex-wrap items-center gap-3">
//                   <p className="text-3xl sm:text-4xl font-bold text-gray-900">
//                     {stats?.orders.total ?? 0}
//                   </p>
//                   <span className="rounded-full bg-indigo-100 px-3 py-1 text-[11px] sm:text-xs font-semibold text-indigo-700 shadow-sm">
//                     Total
//                   </span>
//                 </div>
//                 <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-2">
//                   {[
//                     { label: "Completed", value: stats?.orders.completed },
//                     { label: "Work in Progress", value: stats?.orders.wip },
//                     { label: "Pending", value: stats?.orders.notStarted },
//                   ].map((item) => (
//                     <div
//                       key={item.label}
//                       className="rounded-xl bg-gray-50 p-3 shadow-sm hover:bg-gray-100 transition"
//                     >
//                       <p className="text-base sm:text-lg font-semibold text-gray-800">
//                         {item.value ?? 0}
//                       </p>
//                       <p className="text-[10px] sm:text-[11px] uppercase tracking-wide text-gray-500">
//                         {item.label}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//               </>
//             )}
//           </div>

//           {/* Employees Card */}
//           <div className="rounded-2xl border border-gray-100 bg-white p-4 sm:p-5 shadow-md">
//             {statsLoading && !stats ? (
//               <div className="h-28 w-full animate-pulse rounded-xl bg-gray-100" />
//             ) : (
//               <>
//                 <p className="text-[11px] sm:text-xs font-semibold uppercase tracking-wide text-gray-500">
//                   Employees
//                 </p>
//                 <div className="mt-2 flex flex-wrap items-center gap-3">
//                   <p className="text-3xl sm:text-4xl font-bold text-gray-900">
//                     {stats?.employees.total ?? 0}
//                   </p>
//                   <span className="rounded-full bg-emerald-100 px-3 py-1 text-[11px] sm:text-xs font-semibold text-emerald-700 shadow-sm">
//                     Active
//                   </span>
//                 </div>
//                 <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-2">
//                   {[
//                     { label: "Masters", count: stats?.employees.masters },
//                     { label: "Karigars", count: stats?.employees.karigars },
//                     { label: "Job-work", count: stats?.employees.jobwork },
//                     { label: "Groups", count: stats?.employees.groupwork },
//                   ].map((item) => (
//                     <div
//                       key={item.label}
//                       className="rounded-xl bg-gray-50 p-3 shadow-sm hover:bg-gray-100 transition"
//                     >
//                       <p className="text-base sm:text-lg font-semibold text-gray-800">
//                         {item.count ?? 0}
//                       </p>
//                       <p className="text-[10px] sm:text-[11px] uppercase tracking-wide text-gray-500">
//                         {item.label}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//               </>
//             )}
//           </div>

//           {/* Templates Card */}
//           <div className="rounded-2xl border border-gray-100 bg-white p-4 sm:p-5 shadow-sm">
//             {statsLoading && !stats ? (
//               <div className="h-24 w-full animate-pulse rounded-xl bg-gray-100" />
//             ) : (
//               <>
//                 <p className="text-[11px] sm:text-xs font-semibold uppercase tracking-wide text-gray-500">
//                   Design Templates
//                 </p>
//                 <p className="mt-2 text-3xl sm:text-4xl font-semibold text-gray-900">
//                   {stats?.designTemplates ?? 0}
//                 </p>
//                 <p className="mt-1 text-[11px] sm:text-xs text-gray-500">
//                   Registered entries
//                 </p>
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderFilters = () => {
//     if (selectedEmployee) return null;

//     return (
//       <div className="mb-6 grid w-full gap-3 rounded-xl bg-white p-4 shadow-sm md:grid-cols-2">
//         <div className="flex flex-col">
//           <label className="mb-1 text-xs font-medium text-gray-600">
//             Search by Name
//           </label>
//           <input
//             type="text"
//             value={searchName}
//             onChange={(e) => setSearchName(e.target.value)}
//             placeholder="Type employee name..."
//             className="w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-800 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
//           />
//         </div>
//         <div className="flex flex-col">
//           <label className="mb-1 text-xs font-medium text-gray-600">
//             Employee Role
//           </label>
//           <select
//             value={roleFilter}
//             onChange={(e) => setRoleFilter(e.target.value as any)}
//             className="w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-800 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
//           >
//             {EMPLOYEE_TYPE_OPTIONS.map((opt) => (
//               <option key={opt.value || "ALL"} value={opt.value}>
//                 {opt.label}
//               </option>
//             ))}
//           </select>
//         </div>
//       </div>
//     );
//   };

//   const renderPagination = () => {
//     if (selectedEmployee || employees.length === 0) return null;

//     return (
//       <div className="mt-6 flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6 rounded-xl shadow-sm">
//         <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
//           <div>
//             <p className="text-sm text-gray-700">
//               Showing{" "}
//               <span className="font-medium">{(page - 1) * limit + 1}</span> to{" "}
//               <span className="font-medium">
//                 {Math.min(page * limit, totalRecords)}
//               </span>{" "}
//               of <span className="font-medium">{totalRecords}</span> results
//             </p>
//           </div>
//           <div>
//             <nav
//               className="isolate inline-flex -space-x-px rounded-md shadow-sm"
//               aria-label="Pagination"
//             >
//               <button
//                 onClick={handlePrevPage}
//                 disabled={page === 1}
//                 className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20 disabled:bg-gray-100 disabled:opacity-50"
//               >
//                 Previous
//               </button>
//               <span className="relative inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700">
//                 Page {page} of {totalPages}
//               </span>
//               <button
//                 onClick={handleNextPage}
//                 disabled={page === totalPages}
//                 className="relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20 disabled:bg-gray-100 disabled:opacity-50"
//               >
//                 Next
//               </button>
//             </nav>
//           </div>
//         </div>
//         {/* Mobile View Pagination */}
//         <div className="flex flex-1 justify-between sm:hidden">
//           <button
//             onClick={handlePrevPage}
//             disabled={page === 1}
//             className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
//           >
//             Previous
//           </button>
//           <button
//             onClick={handleNextPage}
//             disabled={page === totalPages}
//             className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
//           >
//             Next
//           </button>
//         </div>
//       </div>
//     );
//   };

//   const renderEmployeeGrid = () => {
//     if (selectedEmployee) return null;

//     return (
//       <div className="space-y-4">
//         {/* Loading / Error / Empty States */}
//         {employeesLoading && (
//           <div className="flex justify-center rounded-xl bg-white p-6 shadow-sm">
//             <p className="text-sm text-gray-600">Loading employees...</p>
//           </div>
//         )}
//         {employeesError && (
//           <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
//             {employeesError}
//           </div>
//         )}
//         {!employeesLoading &&
//           !employeesError &&
//           employees.length === 0 && (
//             <div className="rounded-xl bg-white p-6 text-center text-sm text-gray-500 shadow-sm">
//               No employees found matching criteria.
//             </div>
//           )}

//         {/* The Grid */}
//         <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
//           {employees.map((emp) => (
//             <button
//               key={emp._id}
//               onClick={() => handleEmployeeClick(emp)}
//               className="flex h-full flex-col justify-between rounded-2xl border border-gray-200 bg-white p-4 text-left shadow-sm transition hover:-translate-y-0.5 hover:border-indigo-400 hover:shadow-md"
//             >
//               <div className="mb-3 flex items-center gap-3">
//                 <div className="flex h-10 w-10 items-center justify-center rounded-full bg-indigo-100 text-indigo-600">
//                   <span className="text-sm font-semibold">
//                     {emp.fullName.charAt(0).toUpperCase()}
//                   </span>
//                 </div>
//                 <div className="min-w-0">
//                   <p
//                     className="truncate text-sm font-semibold text-gray-800"
//                     title={emp.fullName}
//                   >
//                     {emp.fullName}
//                   </p>
//                   <p className="truncate text-xs text-gray-500">
//                     {emp.username} • {emp.location}
//                   </p>
//                 </div>
//               </div>

//               <div className="flex items-center justify-between">
//                 <span
//                   className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
//                     emp.employeeType === "Master"
//                       ? "bg-indigo-50 text-indigo-700"
//                       : emp.employeeType === "Karigar"
//                       ? "bg-emerald-50 text-emerald-700"
//                       : emp.employeeType === "job-work"
//                       ? "bg-orange-50 text-orange-700"
//                       : "bg-pink-50 text-pink-700"
//                   }`}
//                 >
//                   {emp.employeeType}
//                 </span>

//                 <span
//                   className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium ${
//                     emp.availabilityStatus === "Available"
//                       ? "bg-green-50 text-green-700"
//                       : "bg-amber-50 text-amber-700"
//                   }`}
//                 >
//                   <span
//                     className={`mr-1.5 h-1.5 w-1.5 rounded-full ${
//                       emp.availabilityStatus === "Available"
//                         ? "bg-green-500"
//                         : "bg-amber-500"
//                     }`}
//                   />
//                   {emp.availabilityStatus}
//                 </span>
//               </div>
//             </button>
//           ))}
//         </div>
        
//         {/* Pagination Controls */}
//         {renderPagination()}
//       </div>
//     );
//   };

//   // -----------------------------
//   // 6. Main Render
//   // -----------------------------
//   return (
//     <div className="min-h-screen bg-gray-50 ">
//       <div className="mx-auto w-full max-w-7xl">
//         {/* Page Header */}
//         <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
//           <div className="space-y-1">
//             <h1 className="text-xl sm:text-2xl font-semibold text-gray-800">
//               Dashboard
//             </h1>
//             <p className="text-[11px] sm:text-xs text-gray-500">
//               Overview of orders, employees, and design templates.
//             </p>
//           </div>
//           {selectedEmployee && (
//             <button
//               onClick={handleBack}
//               className="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-xs sm:text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-100"
//             >
//               ← Back to Employees
//             </button>
//           )}
//         </div>

//         {/* View Content */}
//         {renderStatsSection()}
//         {renderFilters()}
//         {renderEmployeeGrid()}

//         {selectedEmployee && (
//           <div className="mt-4">
//             <PieceWorkEmployeeDetail
//               employee={selectedEmployee}
//               startDate={startDate}
//               endDate={endDate}
//               onStartDateChange={setStartDate}
//               onEndDateChange={setEndDate}
//               report={report}
//               reportLoading={reportLoading}
//               reportError={reportError}
//             />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PieceWorkDashboardAdmin;



import React, { useEffect, useState, useCallback } from "react";
import axiosApi from "../server/service";
import PieceWorkEmployeeDetail from "../component/PieceWorkEmployeeDetail";
import {
  CalendarDaysIcon,
  FunnelIcon,
  BriefcaseIcon,
} from "@heroicons/react/24/outline";

// ==========================================
// Types & Interfaces
// ==========================================

export type EmployeeType = "Master" | "Karigar" | "job-work" | "Group Work";

export interface Employee {
  _id: string;
  fullName: string;
  username: string;
  employeeType?: EmployeeType | null;
  availabilityStatus: "Available" | "Busy";
  location: "Mumbai" | "Surat";
  groupMembers?: { _id?: string; name: string }[];
}

export interface PieceWorkTask {
  lotNumber: string;
  segmentName: string;
  pieces: number;
  assignedAt: string | null;
  completedAt: string | null;
  memberName?: string;
  memberId?: string;

  completionSteps?: {             
    fabric?: boolean;             
    astar?: boolean;              
    embroidery?: boolean;        
  };   

}

export interface PieceWorkReportData {
  employeeId: string;
  employeeName: string;
  employeeType: EmployeeType;
  summary: {
    completed: number;
    incomplete: number;
    inProgress: number;
    total: number;
  };
  totalPiecesCompleted: number;
  tasks: PieceWorkTask[];
}

interface PieceWorkReportResponse {
  success: boolean;
  data?: PieceWorkReportData;
  message?: string;
}

interface UsersApiResponse {
  success: boolean;
  data: Employee[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

// -- Stats Types --
interface OrdersStats {
  total: number;
  completed: number;
  wip: number;
  notStarted: number;
}

interface EmployeesStats {
  total: number;
  masters: number;
  karigars: number;
  jobwork: number;
  groupwork: number;
}

interface DashboardStats {
  orders: OrdersStats;
  employees: EmployeesStats;
  designTemplates: number;
}

interface DashboardStatsResponse {
  success: boolean;
  data?: DashboardStats;
  message?: string;
}

// ==========================================
// Constants
// ==========================================

const EMPLOYEE_TYPE_OPTIONS: { label: string; value: "" | EmployeeType }[] = [
  { label: "All Roles", value: "" },
  { label: "Master", value: "Master" },
  { label: "Karigar", value: "Karigar" },
  { label: "Job Work", value: "job-work" },
  { label: "Group Work", value: "Group Work" },
];

// ==========================================
// Main Component
// ==========================================

const PieceWorkDashboardAdmin: React.FC = () => {
  // -----------------------------
  // 1. State Management
  // -----------------------------

  // View State
  const [selectedEmployee, setSelectedEmployee] = useState<Employee | null>(
    null
  );

  // Filters State (date range)
  const [startDate, setStartDate] = useState<string>(() => {
    const d = new Date();
    d.setDate(d.getDate() - 7);
    return d.toISOString().slice(0, 10);
  });
  const [endDate, setEndDate] = useState<string>(() =>
    new Date().toISOString().slice(0, 10)
  );

  // Search & Filter (Backend Driven)
  const [searchName, setSearchName] = useState<string>("");
  const [roleFilter, setRoleFilter] = useState<"" | EmployeeType>("");

  // Pagination State
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(12);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);

  // Data State: Employees
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [employeesLoading, setEmployeesLoading] = useState<boolean>(false);
  const [employeesError, setEmployeesError] = useState<string | null>(null);

  // Data State: Stats
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [statsLoading, setStatsLoading] = useState<boolean>(false);
  const [statsError, setStatsError] = useState<string | null>(null);

  // Data State: Report
  const [report, setReport] = useState<PieceWorkReportData | null>(null);
  const [reportLoading, setReportLoading] = useState<boolean>(false);
  const [reportError, setReportError] = useState<string | null>(null);

  // Advanced table filters (server-side)
  const [lotFilter, setLotFilter] = useState<string>("");
  const [segmentFilter, setSegmentFilter] = useState<string>("");
  const [memberFilter, setMemberFilter] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<
    "" | "completed" | "incomplete" | "in-progress"
  >("");
  const [assignedFrom, setAssignedFrom] = useState<string>("");
  const [assignedTo, setAssignedTo] = useState<string>("");
  const [finishedFrom, setFinishedFrom] = useState<string>("");
  const [finishedTo, setFinishedTo] = useState<string>("");

  // -----------------------------
  // 2. Responsive Limit Logic
  // -----------------------------
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setLimit(8);
      } else if (width < 1024) {
        setLimit(10);
      } else {
        setLimit(12);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // -----------------------------
  // 3. Data Fetching
  // -----------------------------

  // Reset page to 1 when filters change
  useEffect(() => {
    setPage(1);
  }, [searchName, roleFilter]);

  // Fetch Employees (Backend Pagination & Filtering)
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        setEmployeesLoading(true);
        setEmployeesError(null);

        const response = await axiosApi.get<UsersApiResponse>(
          "/api/users/by-type-dashboard",
          {
            params: {
              page,
              limit,
              search: searchName,
              employeeType: roleFilter,
              includeAll: "true",
            },
          }
        );

        if (response.data.success) {
          setEmployees(response.data.data);
          setTotalPages(response.data.pagination.totalPages);
          setTotalRecords(response.data.pagination.total);
        } else {
          setEmployees([]);
        }
      } catch (err: any) {
        console.error("fetchEmployees error:", err);
        setEmployeesError("Error fetching employees");
      } finally {
        setEmployeesLoading(false);
      }
    };

    const timeoutId = setTimeout(() => {
      fetchEmployees();
    }, 400);

    return () => clearTimeout(timeoutId);
  }, [page, limit, searchName, roleFilter]);

  // Fetch Stats (Once)
  useEffect(() => {
    const fetchStats = async () => {
      try {
        setStatsLoading(true);
        const response = await axiosApi.get<DashboardStatsResponse>(
          "/api/dashboard/stats"
        );
        if (response.data.success) {
          setStats(response.data.data || null);
        }
      } catch (err) {
        console.error("fetchStats error:", err);
        setStatsError("Error fetching stats");
      } finally {
        setStatsLoading(false);
      }
    };
    fetchStats();
  }, []);

  // Fetch Detailed Report (with advanced filters)
  const fetchReport = useCallback(
    async (employee: Employee) => {
      if (!startDate || !endDate) {
        setReportError("Please select both Start Date and End Date.");
        return;
      }
      try {
        setReportLoading(true);
        setReportError(null);
        setReport(null);

        const response = await axiosApi.get<PieceWorkReportResponse>(
          "api/dashboard/piece-work-report",
          {
            params: {
              startDate,
              endDate,
              employeeId: employee._id,
              lotNumber: lotFilter || undefined,
              segmentName: segmentFilter || undefined,
              memberId:
                employee.employeeType === "Group Work" && memberFilter
                  ? memberFilter
                  : undefined,
              status: statusFilter || undefined,
              assignedFrom: assignedFrom || undefined,
              assignedTo: assignedTo || undefined,
              finishedFrom: finishedFrom || undefined,
              finishedTo: finishedTo || undefined,
            },
          }
        );

        if (response.data.success) {
          setReport(response.data.data || null);
        }
      } catch (err: any) {
        setReportError("Error fetching report details");
      } finally {
        setReportLoading(false);
      }
    },
    [
      startDate,
      endDate,
      lotFilter,
      segmentFilter,
      memberFilter,
      statusFilter,
      assignedFrom,
      assignedTo,
      finishedFrom,
      finishedTo,
    ]
  );

  const handleClearFilters = () => {
  setLotFilter("");
  setSegmentFilter("");
  setMemberFilter("");
  setStatusFilter("");
  setAssignedFrom("");
  setAssignedTo("");
  setFinishedFrom("");
  setFinishedTo("");
};


  useEffect(() => {
    if (selectedEmployee) {
      fetchReport(selectedEmployee);
    }
  }, [selectedEmployee, startDate, endDate, fetchReport]);

  // -----------------------------
  // 4. Handlers
  // -----------------------------

  const handleEmployeeClick = (employee: Employee) => {
    setSelectedEmployee(employee);
    if (employee.employeeType !== "Group Work") {
      setMemberFilter("");
    }
  };

  const handleBack = () => {
    setSelectedEmployee(null);
    setReport(null);
    setReportError(null);

    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 7);

    setStartDate(start.toISOString().slice(0, 10));
    setEndDate(end.toISOString().slice(0, 10));

    // reset advanced filters
    // setLotFilter("");
    // setSegmentFilter("");
    // setMemberFilter("");
    // setStatusFilter("");
    // setAssignedFrom("");
    // setAssignedTo("");
    // setFinishedFrom("");
    // setFinishedTo("");

    handleClearFilters();

  };

  const handlePrevPage = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNextPage = () => {
    if (page < totalPages) setPage((prev) => prev + 1);
  };

  // -----------------------------
  // 5. Render Blocks
  // -----------------------------

  const renderStatsSection = () => {
    if (selectedEmployee) return null;

    return (
      <div className="mb-6 space-y-3 animate-fade-in">
        {statsError && (
          <div className="rounded-xl border border-red-200 bg-red-50 p-3 text-xs text-red-700">
            {statsError}
          </div>
        )}

        <div className="grid w-full gap-4 md:grid-cols-[2fr,2fr,1.2fr]">
          {/* Orders Card */}
          <div className="rounded-2xl border border-gray-100 bg-white p-4 sm:p-5 shadow-md">
            {statsLoading && !stats ? (
              <div className="h-28 w-full animate-pulse rounded-xl bg-gray-100" />
            ) : (
              <>
                <p className="text-[11px] sm:text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Orders
                </p>
                <div className="mt-2 flex flex-wrap items-center gap-3">
                  <p className="text-3xl sm:text-4xl font-bold text-gray-900">
                    {stats?.orders.total ?? 0}
                  </p>
                  <span className="rounded-full bg-indigo-100 px-3 py-1 text-[11px] sm:text-xs font-semibold text-indigo-700 shadow-sm">
                    Total
                  </span>
                </div>
                <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-2">
                  {[
                    { label: "Completed", value: stats?.orders.completed },
                    { label: "Work in Progress", value: stats?.orders.wip },
                    { label: "Pending", value: stats?.orders.notStarted },
                  ].map((item) => (
                    <div
                      key={item.label}
                      className="rounded-xl bg-gray-50 p-3 shadow-sm hover:bg-gray-100 transition"
                    >
                      <p className="text-base sm:text-lg font-semibold text-gray-800">
                        {item.value ?? 0}
                      </p>
                      <p className="text-[10px] sm:text-[11px] uppercase tracking-wide text-gray-500">
                        {item.label}
                      </p>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>

          {/* Employees Card */}
          <div className="rounded-2xl border border-gray-100 bg-white p-4 sm:p-5 shadow-md">
            {statsLoading && !stats ? (
              <div className="h-28 w-full animate-pulse rounded-xl bg-gray-100" />
            ) : (
              <>
                <p className="text-[11px] sm:text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Employees
                </p>
                <div className="mt-2 flex flex-wrap items-center gap-3">
                  <p className="text-3xl sm:text-4xl font-bold text-gray-900">
                    {stats?.employees.total ?? 0}
                  </p>
                </div>
                <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-2">
                  {[
                    { label: "Masters", count: stats?.employees.masters },
                    { label: "Karigars", count: stats?.employees.karigars },
                    { label: "Job-work", count: stats?.employees.jobwork },
                    { label: "Groups", count: stats?.employees.groupwork },
                  ].map((item) => (
                    <div
                      key={item.label}
                      className="rounded-xl bg-gray-50 p-3 shadow-sm hover:bg-gray-100 transition"
                    >
                      <p className="text-base sm:text-lg font-semibold text-gray-800">
                        {item.count ?? 0}
                      </p>
                      <p className="text-[10px] sm:text-[11px] uppercase tracking-wide text-gray-500">
                        {item.label}
                      </p>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>

          {/* Templates Card */}
          <div className="rounded-2xl border border-gray-100 bg-white p-4 sm:p-5 shadow-sm">
            {statsLoading && !stats ? (
              <div className="h-24 w-full animate-pulse rounded-xl bg-gray-100" />
            ) : (
              <>
                <p className="text-[11px] sm:text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Design Templates
                </p>
                <p className="mt-2 text-3xl sm:text-4xl font-semibold text-gray-900">
                  {stats?.designTemplates ?? 0}
                </p>
                <p className="mt-1 text-[11px] sm:text-xs text-gray-500">
                  Registered entries
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderFilters = () => {
    if (selectedEmployee) return null;

    return (
      <div className="mb-6 grid w-full gap-3 rounded-xl bg-white p-4 shadow-sm md:grid-cols-2">
        <div className="flex flex-col">
          <label className="mb-1 text-xs font-medium text-gray-600">
            Search by Name
          </label>
          <input
            type="text"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            placeholder="Type employee name..."
            className="w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-800 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-1 text-xs font-medium text-gray-600">
            Employee Role
          </label>
          <select
            value={roleFilter}
            onChange={(e) => setRoleFilter(e.target.value as any)}
            className="w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-800 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
          >
            {EMPLOYEE_TYPE_OPTIONS.map((opt) => (
              <option key={opt.value || "ALL"} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  };

  const renderPagination = () => {
    if (selectedEmployee || employees.length === 0) return null;

    return (
      <div className="mt-6 flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6 rounded-xl shadow-sm">
        <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
          <div>
            <p className="text-sm text-gray-700">
              Showing{" "}
              <span className="font-medium">{(page - 1) * limit + 1}</span> to{" "}
              <span className="font-medium">
                {Math.min(page * limit, totalRecords)}
              </span>{" "}
              of <span className="font-medium">{totalRecords}</span> results
            </p>
          </div>
          <div>
            <nav
              className="isolate inline-flex -space-x-px rounded-md shadow-sm"
              aria-label="Pagination"
            >
              <button
                onClick={handlePrevPage}
                disabled={page === 1}
                className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20 disabled:bg-gray-100 disabled:opacity-50"
              >
                Previous
              </button>
              <span className="relative inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700">
                Page {page} of {totalPages}
              </span>
              <button
                onClick={handleNextPage}
                disabled={page === totalPages}
                className="relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20 disabled:bg-gray-100 disabled:opacity-50"
              >
                Next
              </button>
            </nav>
          </div>
        </div>
        {/* Mobile View Pagination */}
        <div className="flex flex-1 justify-between sm:hidden">
          <button
            onClick={handlePrevPage}
            disabled={page === 1}
            className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Previous
          </button>
          <button
            onClick={handleNextPage}
            disabled={page === totalPages}
            className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    );
  };

  const renderEmployeeGrid = () => {
    if (selectedEmployee) return null;

    return (
      <div className="space-y-4">
        {/* Loading / Error / Empty States */}
        {employeesLoading && (
          <div className="flex justify-center rounded-xl bg-white p-6 shadow-sm">
            <p className="text-sm text-gray-600">Loading employees...</p>
          </div>
        )}
        {employeesError && (
          <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
            {employeesError}
          </div>
        )}
        {!employeesLoading && !employeesError && employees.length === 0 && (
          <div className="rounded-xl bg-white p-6 text-center text-sm text-gray-500 shadow-sm">
            No employees found matching criteria.
          </div>
        )}

        {/* The Grid */}
        <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {employees.map((emp) => (
            <button
              key={emp._id}
              onClick={() => handleEmployeeClick(emp)}
              className="flex h-full flex-col justify-between rounded-2xl border border-gray-200 bg-white p-4 text-left shadow-sm transition hover:-translate-y-0.5 hover:border-indigo-400 hover:shadow-md"
            >
              <div className="mb-3 flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-indigo-100 text-indigo-600">
                  <span className="text-sm font-semibold">
                    {emp.fullName.charAt(0).toUpperCase()}
                  </span>
                </div>
                <div className="min-w-0">
                  <p
                    className="truncate text-sm font-semibold text-gray-800"
                    title={emp.fullName}
                  >
                    {emp.fullName}
                  </p>
                  <p className="truncate text-xs text-gray-500">
                    {emp.username} • {emp.location}
                  </p>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <span
                  className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                    emp.employeeType === "Master"
                      ? "bg-indigo-50 text-indigo-700"
                      : emp.employeeType === "Karigar"
                      ? "bg-emerald-50 text-emerald-700"
                      : emp.employeeType === "job-work"
                      ? "bg-orange-50 text-orange-700"
                      : "bg-pink-50 text-pink-700"
                  }`}
                >
                  {emp.employeeType}
                </span>

                <span
                  className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium ${
                    emp.availabilityStatus === "Available"
                      ? "bg-green-50 text-green-700"
                      : "bg-amber-50 text-amber-700"
                  }`}
                >
                  <span
                    className={`mr-1.5 h-1.5 w-1.5 rounded-full ${
                      emp.availabilityStatus === "Available"
                        ? "bg-green-500"
                        : "bg-amber-500"
                    }`}
                  />
                  {emp.availabilityStatus}
                </span>
              </div>
            </button>
          ))}
        </div>

        {/* Pagination Controls */}
        {renderPagination()}
      </div>
    );
  };

  // -----------------------------
  // 6. Main Render
  // -----------------------------
  return (
    <div className="min-h-screen bg-gray-50 ">
      <div className="mx-auto w-full max-w-7xl">
        {/* Page Header */}
        <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <div className="space-y-1">
            <h1 className="text-xl sm:text-2xl font-semibold text-gray-800">
              Dashboard
            </h1>
            <p className="text-[11px] sm:text-xs text-gray-500">
              Overview of orders, employees, and design templates.
            </p>
          </div>
          {selectedEmployee && (
            <button
              onClick={handleBack}
              className="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-xs sm:text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-100"
            >
              ← Back to Employees
            </button>
          )}
        </div>

        {/* View Content */}
        {renderStatsSection()}
        {renderFilters()}
        {renderEmployeeGrid()}

        {selectedEmployee && (
          <div className="mt-4">
            <PieceWorkEmployeeDetail
              employee={selectedEmployee}
              startDate={startDate}
              endDate={endDate}
              onStartDateChange={setStartDate}
              onEndDateChange={setEndDate}
              report={report}
              reportLoading={reportLoading}
              reportError={reportError}
              // advanced filters props
              lotFilter={lotFilter}
              segmentFilter={segmentFilter}
              memberFilter={memberFilter}
              statusFilter={statusFilter}
              assignedFrom={assignedFrom}
              assignedTo={assignedTo}
              finishedFrom={finishedFrom}
              finishedTo={finishedTo}
              onLotFilterChange={setLotFilter}
              onSegmentFilterChange={setSegmentFilter}
              onMemberFilterChange={setMemberFilter}
              onStatusFilterChange={setStatusFilter}
              onAssignedFromChange={setAssignedFrom}
              onAssignedToChange={setAssignedTo}
              onFinishedFromChange={setFinishedFrom}
              onFinishedToChange={setFinishedTo}
              onClearFilters={handleClearFilters}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PieceWorkDashboardAdmin;
